import React from 'react';
import { GraphListLayout } from './GraphList/GraphListLayout';
import { GraphEditorLayout } from './GraphEditor/GraphEditorLayout';
import { TutorialLayout } from './tutorial/TutorialLayout';

import { createBrowserRouter } from 'react-router-dom';
import { RootLayout } from './RootLayout';
import { SignedInLayout } from './SignedInLayout';
import { LoginPage } from './pages/Login';
import { SignUpPage } from './pages/SignUp';
import { AgentsLayout } from './pages/Agents/AgentsLayout';

export const router = createBrowserRouter([
    {
        element: <RootLayout />,
        children: [
            { path: '/login/*', element: <LoginPage /> },
            { path: '/sign-up/*', element: <SignUpPage /> },
            { path: '/tutorial/*', element: <TutorialLayout /> },
            {
                element: <SignedInLayout />,
                path: '/',
                children: [
                    { path: '/', element: <GraphListLayout /> },
                    { path: '/agents', element: <AgentsLayout /> },
                    { path: '/graph/:graphId', element: <GraphEditorLayout /> },
                ],
            },
        ],
    },
]);
